import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Button, Input, InputNumber, Select, Space } from 'antd';
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { toInt } from "../../../../swzutils/TypeUtils";
import { UnitOfMeasureEnum } from "../../api/Representation";
import UnitOfMeasureType from "../../enums/UnitOfMeasureType";
const QtyRangeUOMSearchTableFilter = (props) => {
    const [min, setMin] = useState((props.defaultMin && props.defaultMin.length > 0) ? toInt(props.defaultMin[0], null) : null);
    const [max, setMax] = useState((props.defaultMax && props.defaultMax.length > 0) ? toInt(props.defaultMax[0], null) : null);
    const [unitOfMeasure, setUnitOfMeasure] = useState((props.defaultUnitOfMeasure && props.defaultUnitOfMeasure.length > 0) ? props.defaultUnitOfMeasure[0] : null);
    const [searchTerm, setSearchTerm] = useState(null);
    const maxInputRef = useRef(null);
    const applyFilterClicked = () => {
        props.onApplyFilter(min ? [min] : null, max ? [max] : null, unitOfMeasure ? [unitOfMeasure] : null, searchTerm ? [searchTerm] : null);
    };
    const clearFilterClicked = () => {
        setMin(null);
        setMax(null);
        setUnitOfMeasure(null);
        setSearchTerm(null);
        props.onClearFilter();
    };
    return (_jsxs("div", { className: "custom-filter-dropdown", children: [_jsxs("div", { children: [_jsx(InputNumber, { placeholder: "Min", style: { width: "90px" }, value: min, onChange: setMin, onPressEnter: () => maxInputRef.current?.focus() }), "\u00A0-\u00A0", _jsx(InputNumber, { ref: maxInputRef, placeholder: "Max", style: { width: "90px" }, value: max, onChange: setMax, onPressEnter: applyFilterClicked })] }), _jsx("div", { className: "pt-20", children: _jsx(Select, { onChange: setUnitOfMeasure, value: unitOfMeasure, allowClear: true, defaultActiveFirstOption: false, placeholder: "Unit of measure", style: { width: "100%" }, showSearch: {
                        optionFilterProp: ['label']
                    }, options: UnitOfMeasureType.consignmentFreightSelectOptionsArray() }) }), props.search &&
                _jsx("div", { className: "pt-20", children: _jsx(Input, { placeholder: props.search.placeholder ?? "Product", value: searchTerm ?? '', allowClear: true, style: { width: "100%" }, onChange: (e) => setSearchTerm(e.target.value), onPressEnter: applyFilterClicked }) }), _jsxs(Space, { className: "pt-20", children: [_jsxs(Button, { type: "primary", onClick: applyFilterClicked, children: [_jsx(SearchOutlined, {}), " Apply"] }), _jsxs(Button, { type: "default", onClick: clearFilterClicked, children: [_jsx(CloseOutlined, {}), " Clear"] })] })] }));
};
const qtyRangeUOMSearchTableFilter = (qtyEqualOrGreaterThanRequestKey, qtyEqualOrLessThanRequestKey, unitOfMeasureRequestKey, search) => {
    return (col, filters, openFilterKey, setOpenFilterKey, applyFilterKeys, clearFilterKeys) => {
        const filter = col.filter;
        return {
            ...col,
            key: `unused-${filter.requestKey}`,
            filterMultiple: false,
            filteredValue: filters[qtyEqualOrGreaterThanRequestKey]
                || filters[qtyEqualOrLessThanRequestKey]
                || filters[unitOfMeasureRequestKey]
                || ((search) ? filters[search.requestKey] : null),
            filterDropdownProps: {
                open: openFilterKey === filter.requestKey,
                onOpenChange: (visible) => {
                    setOpenFilterKey(visible ? filter.requestKey : undefined);
                }
            },
            filterDropdown: (_jsx(QtyRangeUOMSearchTableFilter, { defaultMin: filters[qtyEqualOrGreaterThanRequestKey], defaultMax: filters[qtyEqualOrLessThanRequestKey], defaultUnitOfMeasure: filters[unitOfMeasureRequestKey], search: search, onApplyFilter: (min, max, unitOfMeasure, searchTerm) => {
                    const filterKeys = {
                        [qtyEqualOrGreaterThanRequestKey]: min,
                        [qtyEqualOrLessThanRequestKey]: max,
                        [unitOfMeasureRequestKey]: unitOfMeasure,
                    };
                    if (search?.requestKey) {
                        filterKeys[search?.requestKey] = searchTerm;
                    }
                    applyFilterKeys(filterKeys);
                }, onClearFilter: () => {
                    const filterKeys = [qtyEqualOrGreaterThanRequestKey, qtyEqualOrLessThanRequestKey, unitOfMeasureRequestKey];
                    if (search?.requestKey) {
                        filterKeys.push(search?.requestKey);
                    }
                    clearFilterKeys(filterKeys);
                } }))
        };
    };
};
export default qtyRangeUOMSearchTableFilter;
